import CONSTANTS from '../../util/constants';

const initState = {
    isLoading: false,
   
    getTruckData: [],
    editTruckData: [],
    createTruckData: []
}

const TruckReducer = (state = initState, { type, payload }) => {

    
    switch (type) {
        case CONSTANTS.CONSTANTS_TRUCK_MANAGEMENT.GET_TRUCK_API_SUCCESS:
            return {
                ...state,
                getTruckData: payload.value
            }

        case CONSTANTS.CONSTANTS_TRUCK_MANAGEMENT.EDIT_TRUCK_API_SUCCESS:
            return {
                ...state,
                editTruckData: payload.value
            }

        case CONSTANTS.CONSTANTS_TRUCK_MANAGEMENT.ADD_TRUCK_API_SUCCESS:
            return {
                ...state,
                createTruckData: payload.value
            }

       

        default:
            return state
    }
}

export default TruckReducer;
